/**
 * 存钱罐任务类型枚举
 * 任务类型: 0-未知;1-首充;2-充值;3-casino投注;4-sports报名;5-rummy参赛;6-邀请;7-提现
 */
export enum GullakTaskType {
  /** 未知 */
  Unknown = '0',
  /** 首充 */
  FirstDeposit = '1',
  /** 充值 */
  Deposit = '2',
  /** casino投注 */
  CasinoBet = '3',
  /** sports报名 */
  SportsJoin = '4',
  /** rummy参赛 */
  RummyJoin = '5',
  /** 邀请 */
  Invite = '6',
  /** 提现 */
  Withdraw = '7',
  /** 绑定手机 */
  BindPhone = '11'
}

// 一次性任务
export const ONCE_TASKS = [GullakTaskType.FirstDeposit, GullakTaskType.BindPhone]

export const BET_TASKS = [GullakTaskType.Deposit, GullakTaskType.CasinoBet, GullakTaskType.RummyJoin, GullakTaskType.Withdraw];

/**
 * 任务完成状态枚举
 */
export enum TaskFinishStatus {
  /** 未完成 */
  Unfinished = 0,
  /** 已完成 */
  Finished = 1,
}

/**
 * 数值类型枚举
 */
export enum NumericalType {
  /** 金额 */
  Amount = '1',
  /** 比例 */
  Percentage = '2',
}

